import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { getEntity, updateEntity, createEntity, reset } from './kpi-data.reducer';
import { IKpiData } from 'app/shared/model/kpi-data.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const KpiDataUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const kpiDataEntity = useAppSelector(state => state.kpiData.entity);
  const loading = useAppSelector(state => state.kpiData.loading);
  const updating = useAppSelector(state => state.kpiData.updating);
  const updateSuccess = useAppSelector(state => state.kpiData.updateSuccess);

  const handleClose = () => {
    props.history.push('/kpi-data' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...kpiDataEntity,
      ...values,
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...kpiDataEntity,
          created: convertDateTimeFromServer(kpiDataEntity.created),
          truckImplementId: kpiDataEntity?.truckImplement?.id,
          companyId: kpiDataEntity?.company?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.kpiData.home.createOrEditLabel" data-cy="KpiDataCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.kpiData.home.createOrEditLabel">Create or edit a KpiData</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="kpi-data-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.kpiData.created')}
                id="kpi-data-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField label={translate('fleetSenseApp.kpiData.odometer')} id="kpi-data-odometer" name="odometer" data-cy="odometer" type="text" />
              <ValidatedField
                label={translate('fleetSenseApp.kpiData.distanceTravelled')}
                id="kpi-data-distanceTravelled"
                name="distanceTravelled"
                data-cy="distanceTravelled"
                type="text"
              />
              <ValidatedField label={translate('fleetSenseApp.kpiData.speedAvg')} id="kpi-data-speedAvg" name="speedAvg" data-cy="speedAvg" type="text" />
              <ValidatedField label={translate('fleetSenseApp.kpiData.speedMax')} id="kpi-data-speedMax" name="speedMax" data-cy="speedMax" type="text" />
              <ValidatedField label={translate('fleetSenseApp.kpiData.speedMin')} id="kpi-data-speedMin" name="speedMin" data-cy="speedMin" type="text" />
              <ValidatedField label={translate('fleetSenseApp.kpiData.loadAvg')} id="kpi-data-loadAvg" name="loadAvg" data-cy="loadAvg" type="text" />
              <ValidatedField label={translate('fleetSenseApp.kpiData.loadMax')} id="kpi-data-loadMax" name="loadMax" data-cy="loadMax" type="text" />
              <ValidatedField label={translate('fleetSenseApp.kpiData.loadMin')} id="kpi-data-loadMin" name="loadMin" data-cy="loadMin" type="text" />
              <ValidatedField label={translate('fleetSenseApp.kpiData.absCount')} id="kpi-data-absCount" name="absCount" data-cy="absCount" type="text" />
              <ValidatedField label={translate('fleetSenseApp.kpiData.absMax')} id="kpi-data-absMax" name="absMax" data-cy="absMax" type="text" />
              <ValidatedField label={translate('fleetSenseApp.kpiData.rssCount')} id="kpi-data-rssCount" name="rssCount" data-cy="rssCount" type="text" />
              <ValidatedField label={translate('fleetSenseApp.kpiData.rssMax')} id="kpi-data-rssMax" name="rssMax" data-cy="rssMax" type="text" />
              <ValidatedField
                label={translate('fleetSenseApp.kpiData.breakCount')}
                id="kpi-data-breakCount"
                name="breakCount"
                data-cy="breakCount"
                type="text"
              />
              <ValidatedField label={translate('fleetSenseApp.kpiData.breakMax')} id="kpi-data-breakMax" name="breakMax" data-cy="breakMax" type="text" />
              <ValidatedField
                label={translate('fleetSenseApp.kpiData.breakCountDistanceHundred')}
                id="kpi-data-breakCountDistanceHundred"
                name="breakCountDistanceHundred"
                data-cy="breakCountDistanceHundred"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.kpiData.breakMaxOdometerHundred')}
                id="kpi-data-breakMaxOdometerHundred"
                name="breakMaxOdometerHundred"
                data-cy="breakMaxOdometerHundred"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.kpiData.alertTotalCount')}
                id="kpi-data-alertTotalCount"
                name="alertTotalCount"
                data-cy="alertTotalCount"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.kpiData.alertSensorCount')}
                id="kpi-data-alertSensorCount"
                name="alertSensorCount"
                data-cy="alertSensorCount"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.kpiData.alertFenceCount')}
                id="kpi-data-alertFenceCount"
                name="alertFenceCount"
                data-cy="alertFenceCount"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.kpiData.alertIdentificationCount')}
                id="kpi-data-alertIdentificationCount"
                name="alertIdentificationCount"
                data-cy="alertIdentificationCount"
                type="text"
              />
              <ValidatedField
                id="kpi-data-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.kpiData.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField id="kpi-data-company" name="companyId" data-cy="company" label={translate('fleetSenseApp.kpiData.company')} type="select">
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/kpi-data" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default KpiDataUpdate;
